import { useTranslation } from "react-i18next";
import React from "react";

const useDynamicTranslation = (sections = "common") => {
  const { t } = useTranslation();

  // Ensure sections is always an array
  const sectionsArray = Array.isArray(sections) ? sections : [sections];

  // Fetch translations for the provided sections
  const getTranslations = () => {
    return sectionsArray.reduce((acc, section) => {
      const sectionTranslations = t(section, { returnObjects: true });
      if (
        typeof sectionTranslations === "object" &&
        sectionTranslations !== null
      ) {
        if (section === "common") {
          return { ...acc, ...sectionTranslations };
        }
        return { ...acc, [section]: sectionTranslations };
      }
      console.warn(`No translations found for section: ${section}`);
      return acc;
    }, {});
  };

  const translations = getTranslations();

  const getTranslated = (key, parentPath = null) => {
    if (parentPath) {
      const keys = parentPath.split(".");
      let nestedTranslations = translations;

      for (const k of keys) {
        if (nestedTranslations && nestedTranslations[k]) {
          nestedTranslations = nestedTranslations[k];
        } else {
          console.warn(
            `No translation found for nested key: ${k} in path: ${parentPath}`
          );
          return key; // Fallback to the key if not found
        }
      }

      return nestedTranslations[key] || key;
    } else if (translations[key]) {
      return translations[key];
    }

    console.warn(`No translation found for key: ${key}`);
    return key;
  };

  const renderTranslated = (key, parentPath = null) => {
    const translation = getTranslated(key, parentPath);

    // Check for <a> tags and parse them
    if (/<a\s+href=["'].*?["'].*?>.*?<\/a>/i.test(translation)) {
      const parts = translation.split(/(<a\s+href=["'].*?["'].*?>.*?<\/a>)/i);
      return (
        <span>
          {parts.map((part, index) => {
            if (/<a\s+href=["'].*?["'].*?>.*?<\/a>/i.test(part)) {
              // Extract href and text content
              const hrefMatch = part.match(/href=["'](.*?)["']/i);
              const textMatch = part.match(/>(.*?)<\/a>/i);
              const href = hrefMatch ? hrefMatch[1] : "#";
              const text = textMatch ? textMatch[1] : "Click Here";

              return (
                <a
                  key={index}
                  href={href}
                  className="text-orange font-bold"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {text}
                </a>
              );
            }
            return <span key={index}>{part}</span>;
          })}
        </span>
      );
    }

    return <span>{translation}</span>;
  };

  return { getTranslated, renderTranslated };
};

export default useDynamicTranslation;
